(function () {
  // Add custom code below this line

  // Check if device has touch capability
  if (window.theme.touch) {
    // Wait for DOM to be fully loaded
    // For native HTML5 videos
    console.log('Touch device detected. Removing videos from DOM to save resources.');

    const productItemVideos = document.querySelectorAll('.product-item__bg__under video');

    if (productItemVideos.length > 0) {
      productItemVideos.forEach((video) => {
        // Get the parent element
        const parent = video.parentElement;

        // Check if we can find an image alternative to replace the video
        if (video.poster) {
          imgSrc = video.poster;
        } else if (video.getAttribute('data-poster')) {
          imgSrc = video.getAttribute('data-poster');
        }

        // Remove the video element completely
        video.src = '';
        video.load();
        video.remove();
      });
    }
  }

  // Privacy consent site blocker — blocks navigation/scroll until Shopify banner is accepted
  (function initPrivacyBlocker() {
    const BLOCK_ATTR = 'data-privacy-blocked';
    const PENDING_CLASS = 'privacy-pending';
    const BACKDROP_ID = 'privacy-consent-backdrop';
    const BANNER_SELECTORS = '#shopify-pc__banner, .shopify-pc__banner__dialog';
    const PREFS_SELECTOR = '#shopify-pc__prefs';
    const PREFS_SCROLLABLE_SELECTOR = '.shopify-pc__prefs__scrollable';
    const KLAVIYO_SELECTORS =
      '.klaviyo-form, [class*="klaviyo-form"], .needsclick[formtype], [class*="kl-private"]';
    const ALLOWED_SELECTORS = `${BANNER_SELECTORS}, ${PREFS_SELECTOR}, ${PREFS_SCROLLABLE_SELECTOR}, ${KLAVIYO_SELECTORS}`;
    const ACCEPT_SELECTOR = '.shopify-pc__banner__btn-accept';
    const BANNER_WAIT_MS = 10000;
    const POLL_INTERVAL_MS = 500;

    let isBlocked = false;
    let pollTimer = null;
    let bannerWaitTimer = null;
    let bannerObserver = null;
    let privacyUiObserver = null;

    function getCustomerPrivacy() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }

    function removePendingState() {
      document.documentElement.classList.remove(PENDING_CLASS);
    }

    function isInsideAllowedTarget(node) {
      if (!node || !(node instanceof Element)) return false;
      return Boolean(
        node.closest(ALLOWED_SELECTORS) || node.closest('[data-scroll-lock-scrollable]')
      );
    }

    function markShopifyPrivacyScrollTargets() {
      document.querySelectorAll(PREFS_SCROLLABLE_SELECTOR).forEach((el) => {
        el.setAttribute('data-scroll-lock-scrollable', '');
      });
    }

    function startPrivacyUiObserver() {
      if (privacyUiObserver) return;

      markShopifyPrivacyScrollTargets();

      privacyUiObserver = new MutationObserver(() => {
        markShopifyPrivacyScrollTargets();
      });

      privacyUiObserver.observe(document.body, { childList: true, subtree: true });
    }

    function stopPrivacyUiObserver() {
      if (privacyUiObserver) {
        privacyUiObserver.disconnect();
        privacyUiObserver = null;
      }
    }

    function needsBlock() {
      const cp = getCustomerPrivacy();
      if (!cp) return false;
      if (window.Shopify && window.Shopify.designMode) return false;

      const trackingConsent = cp.getTrackingConsent && cp.getTrackingConsent();
      const userCanBeTracked = cp.userCanBeTracked && cp.userCanBeTracked();

      return trackingConsent === 'no_interaction' && !userCanBeTracked;
    }

    function blockInteraction(event) {
      if (!isBlocked) return;
      if (isInsideAllowedTarget(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
    }

    function blockKeyboardNav(event) {
      if (!isBlocked) return;
      if (isInsideAllowedTarget(event.target)) return;

      const blockedKeys = ['Tab', 'Enter', ' '];
      if (blockedKeys.includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function addGuards() {
      document.addEventListener('click', blockInteraction, true);
      document.addEventListener('keydown', blockKeyboardNav, true);
    }

    function removeGuards() {
      document.removeEventListener('click', blockInteraction, true);
      document.removeEventListener('keydown', blockKeyboardNav, true);
    }

    function activateBlock() {
      if (isBlocked) return;

      isBlocked = true;
      document.documentElement.setAttribute(BLOCK_ATTR, '');

      if (!document.getElementById(BACKDROP_ID)) {
        const backdrop = document.createElement('div');
        backdrop.id = BACKDROP_ID;
        backdrop.setAttribute('aria-hidden', 'true');
        document.body.appendChild(backdrop);
      }

      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      markShopifyPrivacyScrollTargets();
      startPrivacyUiObserver();
      addGuards();

      // Re-apply scroll targets after theme scroll lock initializes (uses setTimeout).
      setTimeout(markShopifyPrivacyScrollTargets, 50);
    }

    function deactivateBlock() {
      if (!isBlocked) {
        removePendingState();
        return;
      }

      isBlocked = false;
      document.documentElement.removeAttribute(BLOCK_ATTR);
      document.getElementById(BACKDROP_ID)?.remove();
      removeGuards();

      if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
      }

      if (bannerWaitTimer) {
        clearTimeout(bannerWaitTimer);
        bannerWaitTimer = null;
      }

      if (bannerObserver) {
        bannerObserver.disconnect();
        bannerObserver = null;
      }

      stopPrivacyUiObserver();

      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      removePendingState();
    }

    function consentResolved() {
      const cp = getCustomerPrivacy();
      if (!cp) return true;
      return cp.getTrackingConsent() !== 'no_interaction';
    }

    function bindAcceptHandlers() {
      document.querySelectorAll(ACCEPT_SELECTOR).forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            setTimeout(() => {
              if (consentResolved()) deactivateBlock();
            }, 100);
          },
          { once: true }
        );
      });
    }

    function startConsentPoll() {
      if (pollTimer) return;

      pollTimer = setInterval(() => {
        if (consentResolved()) {
          deactivateBlock();
        }
      }, POLL_INTERVAL_MS);
    }

    function onBannerFound() {
      if (bannerWaitTimer) {
        clearTimeout(bannerWaitTimer);
        bannerWaitTimer = null;
      }

      if (bannerObserver) {
        bannerObserver.disconnect();
        bannerObserver = null;
      }

      activateBlock();
      bindAcceptHandlers();
      startConsentPoll();
    }

    function waitForBanner(callback) {
      if (document.querySelector(BANNER_SELECTORS)) {
        callback();
        return;
      }

      bannerObserver = new MutationObserver(() => {
        if (document.querySelector(BANNER_SELECTORS)) {
          callback();
        }
      });

      bannerObserver.observe(document.body, { childList: true, subtree: true });

      bannerWaitTimer = setTimeout(() => {
        if (bannerObserver) {
          bannerObserver.disconnect();
          bannerObserver = null;
        }
        removePendingState();
      }, BANNER_WAIT_MS);
    }

    function initAfterApiLoad() {
      removePendingState();

      if (!needsBlock()) return;

      document.documentElement.classList.add(PENDING_CLASS);

      document.addEventListener(
        'visitorConsentCollected',
        () => {
          deactivateBlock();
        },
        { once: true }
      );

      waitForBanner(onBannerFound);
    }

    function loadConsentApi() {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        removePendingState();
        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          if (error) {
            removePendingState();
            return;
          }

          initAfterApiLoad();
        }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadConsentApi);
    } else {
      loadConsentApi();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
